import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@rocksoft/locations-sdk';

@Component({
  selector: 'era-device-health-overview',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-health-overview.component.html',
})
export class DeviceHealthOverviewComponent {
  public readonly location = input.required<Location>();
  public readonly deviceCount = input.required<number>();
}
